import React from 'react';
import { useNavigate } from 'react-router-dom';
import { BreadcrumbsContainer } from '@ibinder/common-frontend';
import BUILD_UP_CHIPS_DATA from '../../../../utils/reversePathRecursive';
import styled from 'styled-components';
import { BINDER_NAME } from '../../placeholderData';

const StyledBreadcrumbs = styled(BreadcrumbsContainer)`
  padding: 0.5rem 1rem;
`;

const BreadcrumbsComponent = ({ tabs, nodeData }) => {
  const CHIPS_DATA = [
    { name: BINDER_NAME },
    // @ts-ignore
    ...BUILD_UP_CHIPS_DATA(nodeData)
  ];

  const navigate = useNavigate();

  const handleClick = (id) => {
    if (id === undefined) {
      navigate(`/`);
    } else {
      navigate(`/tab/${id}`);
    }
  };

  return (
    <StyledBreadcrumbs
      loading={false}
      onClick={handleClick}
      chipsData={CHIPS_DATA}
    />
  );
};

export default BreadcrumbsComponent;
